import { CONFIG } from "../config";

export const NORMAL_PROVIDER = "normal";
export const BR_PROVIDER = "br";
export const DEFAULT_PROVIDER = "saba";
export const MIXED_PROVIDER_MESSAGE =
  "Please place bets from different providers in separate tickets.";
export const SABA_COMBO_MESSAGE =
  "Combo bets are unavailable for SABA football.";

const FOOTBALL_PROVIDER_SCOPES = new Set([
  "football",
  "soccer",
  "fb",
  "fbstep",
  "combofb",
]);

export const isFootballProviderScope = (scope?: string) => {
  const normalizedScope = `${scope ?? ""}`.toLowerCase();

  return FOOTBALL_PROVIDER_SCOPES.has(normalizedScope);
};

export const isSabaComboDisabled = (provider?: string, scope?: string) => {
  if (CONFIG.ENV !== "production") {
    return false;
  }

  if (!isFootballProviderScope(scope)) {
    return false;
  }

  return `${provider ?? ""}`.toLowerCase() === "saba";
};

export const resolveProvider = (provider?: string, scope?: string) => {
  if (CONFIG.ENV !== "production") {
    return provider;
  }

  if (isFootballProviderScope(scope)) {
    return provider;
  }

  return BR_PROVIDER;
};

// Normal provider is the default feed on the backend, so it must be called
// without the provider query string at all.
export const isNormalProvider = (provider?: string) => {
  return !provider || provider === NORMAL_PROVIDER;
};

export const normalizeProviderForComparison = (provider?: string) => {
  if (isNormalProvider(provider)) {
    return NORMAL_PROVIDER;
  }

  const normalizedProvider = `${provider}`.toLowerCase();

  if (normalizedProvider === BR_PROVIDER || normalizedProvider === "betradar") {
    return BR_PROVIDER;
  }

  return normalizedProvider;
};

export const providerQueryString = (provider?: string, scope?: string) => {
  const resolvedProvider = resolveProvider(provider, scope);

  return isNormalProvider(resolvedProvider) ? "" : `?provider=${resolvedProvider}`;
};
